import { createContext } from "react";

export const AgreementsTemplateContext = createContext({});
